<template>
    <v-select
        solo
        dense
        clearable
        label="Select a location"
        v-model="location"
        :items="[allLocationsLabel, ...locations]"
        item-text="locationName" 
        prepend-inner-icon="mdi-map-marker"
        @change="submit"
        return-object />   
</template>

<script>
export default {
    name: 'LocationSelector',
    props: {
        locations: {
            type: Array,
            required: true
        },
        initial: {
            type: String,
            default: null
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        allLocationsLabel: "All locations",
        location: false
    }),
    mounted() {
        this.location = this.initial == "all" ? this.allLocationsLabel : this.initial;
    },
    methods: {
        submit() {
            if (this.location) {
                const location = this.location == this.allLocationsLabel ? "all" : this.location;
                this.$emit('selected', location);
            } else this.$emit('cleared');
        }
    },
    watch: {
        initial(value) {
            console.log(value)
            this.location = value == "all" ? this.allLocationsLabel : value;
        }
    }
}
</script>